import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import MojitoServices from 'mojito/services';

import ViewTypes from 'modules/betting-center/view-types.js';
import Betslip from 'modules/betslip/index.jsx';
import YourBets from 'modules/your-bets/index.jsx';
import { connect } from 'react-redux';

const { TabbedPane, TabbedPaneTab, FlexPane, Text } = MojitoPresentation.Components;
const intentActions = MojitoCore.Intents.actions;
const IntentTypes = MojitoPresentation.Base.Intent.Types;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const { actions: betslipActions } = MojitoServices.Betslip;

class BettingCenterView extends UIViewImplementation {
    constructor(props) {
        super(props);

        this.onSelectedTabChange = this.onSelectedTabChange.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(betslipActions.initBetslip());
    }

    componentWillUnmount() {
        this.props.dispatch(betslipActions.disposeBetslip());
    }

    getTabButtonLabel(config, labelKey, itemsCount) {
        let label = this.resolveString(labelKey);
        if (!config.hidden && !isNaN(itemsCount) && (itemsCount > 0 || config.displayWhenEmpty)) {
            label = this.resolveAndFormatString(
                '$BETTING_CENTER.HEADER_LABEL_WITH_ITEMS_COUNT',
                label,
                itemsCount
            );
        }
        return <Text config={this.config.tabLabel}>{label}</Text>;
    }

    onSelectedTabChange(selectedTabKey) {
        const { dispatch } = this.props;

        switch (selectedTabKey) {
            case ViewTypes.BETSLIP:
                dispatch(intentActions.publishIntent(IntentTypes.SHOW_BETSLIP));
                break;
            case ViewTypes.OPEN_BETS:
                dispatch(intentActions.publishIntent(IntentTypes.SHOW_OPEN_BETS));
                break;
        }
    }

    renderBetslipTab() {
        return (
            <TabbedPaneTab
                selectableKey={ViewTypes.BETSLIP}
                class="ta-betslip"
                buttonContent={this.getTabButtonLabel(
                    this.config.selectionsCount,
                    '$BETTING_CENTER.HEADER_BETSLIP',
                    this.props.betslipItemsCount
                )}
                key={ViewTypes.BETSLIP}
            >
                <Betslip config={this.config.betslip} />
            </TabbedPaneTab>
        );
    }
    renderOpenBetsTab() {
        return (
            <TabbedPaneTab
                selectableKey={ViewTypes.OPEN_BETS}
                class="ta-yourBets"
                buttonContent={this.getTabButtonLabel(
                    this.config.openBetsCount,
                    '$BETTING_CENTER.HEADER_YOUR_BETS',
                    this.props.openBetsCount
                )}
                key={ViewTypes.OPEN_BETS}
            >
                <YourBets config={this.config.yourBets} />
            </TabbedPaneTab>
        );
    }

    renderContent() {
        return (
            <TabbedPane
                selectedKey={this.props.selectedTab}
                onSelectionChange={this.onSelectedTabChange}
                config={this.config.tabs}
            >
                {this.renderBetslipTab()}
                {this.renderOpenBetsTab()}
            </TabbedPane>
        );
    }

    render() {
        return (
            <FlexPane config={this.config.container} class="ta-bettingCenterView">
                {this.renderContent()}
            </FlexPane>
        );
    }
}

export default connect()(BettingCenterView);
